import { DIMENSION_META, DIMENSION_WEIGHTS, MICI_MAX, MICI_MIN, TIER_BANDS } from '../data/methodologyConstants';
import { scoreD1 } from './scoreD1';
import { scoreD2 } from './scoreD2';
import { scoreD3 } from './scoreD3';
import { scoreD4 } from './scoreD4';
import { scoreD5 } from './scoreD5';
import { scoreD6 } from './scoreD6';
import { scoreD7 } from './scoreD7';
import { scoreD8 } from './scoreD8';

const SCORERS = {
  D1: scoreD1,
  D2: scoreD2,
  D3: scoreD3,
  D4: scoreD4,
  D5: scoreD5,
  D6: scoreD6,
  D7: scoreD7,
  D8: scoreD8,
};

export const scoreAllDimensions = (aggregates) => {
  const results = {};
  Object.keys(SCORERS).forEach((id) => {
    results[id] = SCORERS[id](aggregates[id]);
  });
  return results;
};

export const computeComposite = (dimensionScores) =>
  Object.entries(DIMENSION_WEIGHTS).reduce((sum, [id, weight]) => sum + dimensionScores[id].score * weight, 0);

export const rescaleToMici = (composite) => Math.round(MICI_MIN + (composite / 100) * (MICI_MAX - MICI_MIN));

export const tierFromMici = (miciScore) => {
  const band = TIER_BANDS.find((b) => miciScore >= b.min && miciScore <= b.max);
  return band?.tier ?? 'RESTRICTED';
};

export const summaryFromTier = (tier) => TIER_BANDS.find((b) => b.tier === tier)?.summary ?? '';

export const trendFromScore = (score) => {
  if (score >= 70) return 'up';
  if (score <= 55) return 'down';
  return 'neutral';
};

export const buildDimensionRows = (dimensionScores) =>
  Object.keys(DIMENSION_WEIGHTS).map((id) => {
    const { score } = dimensionScores[id];
    const rounded = Math.round(score);
    const meta = DIMENSION_META[id];
    return {
      id,
      weight: `${Math.round(DIMENSION_WEIGHTS[id] * 100)}%`,
      title: meta.title,
      score: rounded,
      trend: trendFromScore(rounded),
      color: meta.color,
      contribution: dimensionScores[id].score * DIMENSION_WEIGHTS[id],
    };
  });

export const composeMici = (aggregates) => {
  const dimensionScores = scoreAllDimensions(aggregates);
  const composite = computeComposite(dimensionScores);
  const miciScore = rescaleToMici(composite);
  const tier = tierFromMici(miciScore);

  return {
    dimensionScores,
    composite,
    miciScore,
    tier,
    summary: summaryFromTier(tier),
    dimensions: buildDimensionRows(dimensionScores),
  };
};
